import { fetchGet, fetchPost, fetchDelete, fetchPatch } from "@/lib/services";

export interface HolidayPayload {
  Date: string;
  Name_Of_The_Festival: string;
  Day_Of_Week: string;
  Month: string;
  Year: number;
}

export async function getHolidays(year?: number,page?: number, search?: string) {
  const params = new URLSearchParams();
     if (year) params.append('Year', String(year));
   if (page && page > 1) params.append('page', String(page));
  if (search) params.append('Search', search.trim());

  return await fetchGet(`/holidays/?${params.toString()}`);
}

export async function createHoliday(data: HolidayPayload) {
  return await fetchPost('/holidays/', data);
}

export async function createHolidayFromExcel(file: File) {
  const form = new FormData();
  form.append('HolidayFile', file);
  return await fetchPost('/holidays/', form, true);
}

export async function updateHoliday(id: number, data: HolidayPayload) {
  return await fetchPatch(`/holidays/${id}/`, data);
}

export async function deleteHoliday(id: number) {
  return await fetchDelete(`/holidays/${id}/`);
}
